<template>
    <div class="home-container">
      <div class="d-flex flex-column align-items-center justify-content-center gap-3">
        <h5 class="extra-large-text">დაამატეთ მუნიციპალიტეტი</h5>
        <form class="add-organization-form modal-form-grid-wrapper p-4 border-radius-10" @submit.prevent="addMunicipalities">
          <fieldset class="d-flex flex-column align-items-start gap-1 light-gray-color light-text">
            <label for="municipalityName" class="ms-2">მუნიციპალიტეტის სახელი(ქართულად)</label>
            <input v-model="municipalityDataVModels.municipality" pattern="[\u10A0-\u10FF\d !@#$^&\(\)\/*.+,_:?\-\\]+" type="text" autocomplete="off" name="municipalityName" id="municipalityName" required placeholder="მუნიციპალიტეტის სახელი(ქართულად)" class="blue-part-input large-text">
          </fieldset>
          <fieldset class="d-flex flex-column align-items-end gap-1 light-gray-color light-text">
            <label for="municipalityEngName" class="ms-2">(ინგლისურად)მუნიციპალიტეტის სახელი</label>
            <input v-model="municipalityDataVModels.municipalityeng" pattern="[A-Za-z\d !@#$^&\(\)\/*.+,_:?\-\\]+" type="text" autocomplete="off" name="municipalityEngName" id="municipalityEngName" required placeholder="(ინგლისურად)მუნიციპალიტეტის სახელი" class="blue-part-input large-text">
          </fieldset>
          <div class="button-wrapper d-flex justify-content-center w-100">
            <secondaryButton :disabled="isSending" buttonWidth="max-content" buttonType="submit" class="large-text mt-4">
                <template v-slot:content>
                    დამატება
                </template>
            </secondaryButton>
          </div>
        </form>
        
        <div class="w-100">
            <polygonMapComponent @updatePolygon="updatePolygon" maxHeight="700px"/>
        </div>
      </div>
    </div>
</template>
<script>
import secondaryButton from "@/components/secondaryButton.vue"
import primaryButtonComponent from "@/components/primaryButtonComponent.vue";
import polygonMapComponent from "@/components/polygonMapComponent.vue";
export default {
  data(){
    return {
      municipalityDataVModels: {
        municipality: "",
        municipalityeng: "",
        polygons: [],
      },
      polygon: null,
      isSending: false,
    }
  },
  components: {
    secondaryButton,
    primaryButtonComponent,
    polygonMapComponent,
  },
  methods: {
    updatePolygon(newPolygon){
        if(newPolygon == null){
            this.municipalityDataVModels.polygons = [];
        }
        this.polygon = newPolygon;
    },
    addMunicipalities(){
        let isMunicipalityValid = this.$helper.checkString(this.municipalityDataVModels.municipality);
        let isEngMunicipalityValid = this.$helper.checkEngString(this.municipalityDataVModels.municipalityeng);
        this.municipalityDataVModels.polygons = [];
        let path = [];
        if(this.polygon != null){
            path = this.polygon.getPath();
            path.forEach((latLng, index) => {
                this.municipalityDataVModels.polygons.push({
                    lat: latLng.lat(),
                    lng: latLng.lng(),
                });
            });

        }
        

        if(isMunicipalityValid && isEngMunicipalityValid && this.municipalityDataVModels.polygons.length > 0){
            this.isSending = true;
            this.$store.dispatch("addMunicipalities", this.municipalityDataVModels).then((response) => {
            if(response.status == 201){
                this.$helper.showSwal("მუნიციპალიტეტი წარმატებით დაემატა", "success", "");
                setTimeout(() => {this.$router.go()}, 1500);
            }
            }).catch((error) => {
                if(error?.response?.status == 422){
                    this.$helper.showSwal("მოხდა შეცდომა", "error", "");
                    setTimeout(() => {this.$router.go()}, 1500);
                }
            }).finally(() => {
              this.isSending = false;
            })
        }
    }
  }
}
</script>
<style scoped>
input[type="checkbox"]{
    width: 30px;
    height: 30px;
    cursor: pointer;
}
.home-container{
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(2, min-content);
  row-gap: 1.5em;
}
.add-organization-form{
  background-color: var(--secondary-background-color);
  width: 60%;
}
.modal-form-grid-wrapper{
  /* width: 100%; */
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 1em;
  row-gap: 2em;
}
.modal-form-grid-wrapper .blue-part-input{
  padding-block: 15px;
  max-width: 400px;
}
.button-wrapper{
  grid-column: 1/3;
}
textarea.blue-part-input{
  width: 100%;
  resize: none;
}
.multiselect{
    --ms-placeholder-color: var(--light-blue);
    --ms-tag-bg: var(--light-blue);
    --ms-option-bg-selected: var(--light-blue);
    --ms-option-bg-selected-pointed: var(--light-blue);
    flex: 1;
    max-width: 235px;
    margin: 0;
}
#map{
    height: 500px;
    width: 100%;
}

@media screen and (max-width: 1800px) {
  .add-organization-form{
    width: 70%;
  }
  .modal-form-grid-wrapper{
    column-gap: 2em;
    row-gap: 3em;
  }
}

@media screen and (max-width: 1560px) {
  .modal-form-grid-wrapper{
    column-gap: 2em;
    row-gap: 2em;
  }
  .modal-form-grid-wrapper .blue-part-input{
    padding: 10px;
  }
}
@media screen and (max-width: 1200px) {
  .add-organization-form{
    width: 90%;
  }
}
</style>
